import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getRoomsCounterparty = async () => {
  return await request.get(
    `/RentPlace/office/counterparty`,
    {},
    'При загрузке контрагентов произошла ошибка',
    []
  );
};

const useRoomsCounterparties = (options) =>
  useQuery([queries.roomsCounterparty], () => getRoomsCounterparty(), options);

export default useRoomsCounterparties;
